/* eslint-disable react/no-array-index-key */
import React from 'react';
import lightStyles from './portalStylesLight.module.css';
import darkStyles from './portalStylesDark.module.css';

interface DocumentLink {
  name: string;
  uri: string;
}

interface Props {
  lightMode: boolean;
  notes: string;
  // eslint-disable-next-line react/require-default-props
  documents?: DocumentLink[];
}

const Notes: React.FC<Props> = ({ lightMode, notes, documents }) => {
  const styles = lightMode ? lightStyles : darkStyles;

  return (
    <div className={styles.content} style={{ display: 'flex', alignItems: 'flex-start', gap: '2rem', flex: 1 }}>
      <div style={{ flex: 3 }}>
        <h3 className={styles.subTabButtonActive}>Notes</h3>
        <div className={styles.dropdownContent}>
          <p style={{ margin: 0 }}>{notes}</p>
        </div>
      </div>

      {documents && documents.length > 0 && (
        <div style={{ flex: 1 }}>
          <h4 className={styles.subTabButtonActive}>Documents</h4>
          <div className={styles.dropdownContent} style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            {documents.map((doc, index) => (
              <a
                key={index}
                href={doc.uri}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.subTabButtonActive}
              >
                {doc.name}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Notes;
